import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { ErrorBoundary, FatalError } from './components/ErrorBoundary'
import './styles/global.css'

const root = document.getElementById('root')
if (!root) throw new Error('#root not found')

const reactRoot = createRoot(root)

/* App's module graph pulls in src/lib/supabase.ts, which throws during import
   when its env vars are missing. That happens before any component renders, so
   an ErrorBoundary would never mount to catch it — hence the dynamic import.
   The boundary still wraps the app for render-time and lifecycle errors. */
import('./App')
  .then(({ default: App }) => {
    reactRoot.render(
      <StrictMode>
        <ErrorBoundary>
          {/* The router lives inside App (EVE-192: a data router). */}
          <App />
        </ErrorBoundary>
      </StrictMode>,
    )
  })
  .catch((cause: unknown) => {
    const error = cause instanceof Error ? cause : new Error(String(cause))
    console.error('[boot]', error)
    reactRoot.render(<FatalError error={error} />)
  })
